import { repositoryMutation, requiredString } from "./transaction.js";
export class SqliteSyncLedgerRepository {
    #database;
    #now;
    constructor(database, options = {}) {
        this.#database = database;
        this.#now = options.now ?? (() => new Date().toISOString());
    }
    delete(domain) {
        return repositoryMutation(this.#database, (transaction) => {
            if (transaction.selectValue("SELECT COUNT(*) FROM sync_cursors WHERE domain = ?", [domain]) !== 1) {
                return undefined;
            }
            transaction.exec("DELETE FROM sync_cursors WHERE domain = ?", { bind: [domain] });
            return {
                entityId: domain,
                event: {
                    occurredAt: this.#now(),
                    payload: { action: "deleted", entityId: domain, entityType: "sync-cursor" },
                    type: "domain.entity-changed",
                },
            };
        });
    }
    async list() {
        return this.#database.selectObjects("SELECT domain, cursor, updated_at FROM sync_cursors ORDER BY domain").map(syncLedgerRecord);
    }
    async read(domain) {
        const row = this.#database.selectObject("SELECT domain, cursor, updated_at FROM sync_cursors WHERE domain = ?", [domain]);
        return row === undefined ? undefined : syncLedgerRecord(row);
    }
    setCursor(input) {
        return repositoryMutation(this.#database, (transaction) => {
            const updatedAt = this.#now();
            transaction.exec(`INSERT INTO sync_cursors(domain, cursor, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(domain) DO UPDATE SET
            cursor = excluded.cursor,
            updated_at = excluded.updated_at`, { bind: [input.domain, input.cursor, updatedAt] });
            return { entityId: input.domain, event: syncEvent(input, updatedAt) };
        });
    }
}
function syncEvent(input, occurredAt) {
    return { occurredAt, payload: input, type: "sync.delta-applied" };
}
function syncLedgerRecord(row) {
    return {
        cursor: requiredString(row.cursor, "sync cursor"),
        domain: requiredString(row.domain, "sync domain"),
        updatedAt: requiredString(row.updated_at, "sync updated_at"),
    };
}
//# sourceMappingURL=sync-ledger.js.map